module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-jack.236af2e8.svg";